import React from 'react';
import { AlertCircle, Settings } from 'lucide-react';
import { ParameterInput } from './ParameterInput';
import { ParameterTemplate } from './parameterTemplates';

interface ParameterSectionProps {
  template: ParameterTemplate;
  parameters: Record<string, any>;
  errors: Record<string, string>;
  onParameterChange: (key: string, value: any) => void;
}

export const ParameterSection: React.FC<ParameterSectionProps> = ({
  template,
  parameters,
  errors,
  onParameterChange
}) => {
  if (Object.keys(template).length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <Settings className="w-8 h-8 mx-auto mb-2 text-gray-300" />
        <p>No configuration required for this node type.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h4 className="font-medium text-gray-900">Parameters</h4>
      {Object.entries(template).map(([key, config]) => (
        <div key={key} className="space-y-2">
          <label
            className="block text-sm font-medium text-gray-700"
            htmlFor={`parameter-${key}`}
          >
            {config.label}
            {config.required && <span className="text-red-500 ml-1">*</span>}
          </label>
          
          <ParameterInput
            id={`parameter-${key}`}
            paramKey={key}
            config={config}
            value={parameters[key]}
            hasError={!!errors[key]}
            onChange={onParameterChange}
          />
          
          {errors[key] && (
            <div className="flex items-center space-x-1 text-red-600 text-sm">
              <AlertCircle className="w-4 h-4" />
              <span>{errors[key]}</span>
            </div>
          )}
          
          {config.description && !errors[key] && (
            <p className="text-xs text-gray-500">{config.description}</p>
          )}
        </div>
      ))}
    </div>
  );
};